import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component( {
   selector: 'lib-version-expired-dialog',
   template: `
      <h2 mat-dialog-title>Update required</h2>
      <mat-dialog-content>
         <p>A new version of the {{ portalName }} is available — refresh this page to continue.</p>
         <p class="helpdesk-note">If you continue to see this message, please contact helpdesk for assistance.</p>
      </mat-dialog-content>
      <mat-dialog-actions>
         <button mat-raised-button (click)="dialogRef.close()">Refresh now</button>
      </mat-dialog-actions>`
} )
export class VersionExpiredDialogComponent {
   portalName: string;

   constructor(
      public dialogRef: MatDialogRef<VersionExpiredDialogComponent>,
      @Inject( MAT_DIALOG_DATA ) public data: any
   ) {
      this.portalName = data?.portalName ?? 'portal';
   }
}
